// extracted by mini-css-extract-plugin
export default {"buyButton":"mQ1yF","sizeBig":"DjrUZ","hasInCart":"KYsFS","iconCheck":"jbHxU"};